import React, { useContext, useEffect, useState } from 'react';
import { Form, notification, Row, Spin, Table, Tabs } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';

import TitlePage from 'components/theme_components/Title';
import Title from 'components/Title';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import {
  createThirdParty,
  ThirdPartyResponse,
  tpChildRequest,
  updateThirdParty,
} from 'services/thirdParty';
import WizardSteps from 'components/theme_components/WizardSteps';
import ButtonLink from 'components/theme_components/ButtonLink';
import ModalControllerNV from 'components/ModalControllerNV';
import { dateToString, toDatePickerDate } from 'utils/utils2';
import { getMyWizards } from 'services/workflow';
import { useQuery } from 'react-query';
import DataGrid from 'components/theme_components/DataGrid';
import { AuthContext } from 'components/Auth/Auth';
import { useGetThirdPartyDetail } from 'pages/ThirdParty/ThirdPartyDetail/useGetThirdPartyDetail';
import GeneralDataSuperTP from './components/GeneralDataSuperTP';
import ThirdPartySearchModal from '../ThirdpartySearch/ThirdPartySearchModal';
import Notifications from 'components/theme_components/Notifications';

export type SuperCompanyCreationProps = {
  tpId?: string;
  phase?: 'LEAD' | 'TP';
  taskid?: number;
  isProposalCreate?: boolean;
  isCreate?: boolean;
  onSelect?: (item: ThirdPartyResponse) => void;
  isModal?: boolean;
};

const TabSuperCompany = (props: SuperCompanyCreationProps) => {
  const { id: paramId } = useParams<{
    id: string;
  }>();
  const { onSelect, isModal, isCreate } = props;

  const { data: wizData } = useQuery(['getMyWizards', 'THIRDPARTY'], () =>
    getMyWizards({ entity: 'THIRDPARTY' }).then((res) => res.data)
  );

  const { data, refetch, isFetching } = useGetThirdPartyDetail(
    isNaN(Number(paramId)) ? undefined : Number(paramId),
    'TP'
  );
  const { isInspect } = useContext(AuthContext);

  const [tpList, setTpList] = useState<any[]>([]);
  const [tpList2, setTpList2] = useState<any[]>([]);
  const [form] = Form.useForm();
  const [current, setCurrent] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [tpChildChanges, setTpChildChanges] = useState<tpChildRequest[]>([]);
  const navigate = useNavigate();

  const addTpToList = (listtp: any[]) => {
    setTpList((prevList) => [...prevList, ...listtp]);
    const mapList = listtp.map((tpdata) => ({
      ...tpdata,
      operation: 'ADD',
    }));

    console.log('mapList', mapList);
    setTpChildChanges((prevChanges) => [...prevChanges, ...mapList]);
  };

  const addTpToList2 = (listtp2: any[]) => {
    setTpList2((prevList2) => [...prevList2, ...listtp2]);
    const mapList = listtp2.map((tpdata) => ({
      ...tpdata,
      operation: 'ADD',
    }));

    console.log('mapList', mapList);
    setTpChildChanges((prevChanges) => [...prevChanges, ...mapList]);
  };
  let thirdParty = data;
  const next = () => {
    form.validateFields().then(() => {
      setCurrent((prev) => prev + 1);
    });
  };
  const prev = () => setCurrent((prev) => prev - 1);

  const columns = [
    {
      dataIndex: 'tpname',
    },
    {
      comcode: 'tpmainadrcity',
      dataIndex: "tpmainadrcity",
    },
    {
      title: '  ',
      render: (val: any, record: any) => {
        return (
          <Row justify="center">
            <DeleteOutlined
              onClick={() => handleDelete(record)}
              style={{ cursor: 'pointer' }}
            />
          </Row>
        );
      },
      width: 10,
      className: 'pr-8',
    },
  ];
  const columns2 = [
    {
      dataIndex: 'tpname',
    },
    {
      comcode: 'tpmainadrcity',
      dataIndex: thirdParty ? 'tpcity' : 'tpmainadrcity',
    },
    {
      render: (val: any, record: any) => {
        return (
          <Row justify="center">
            <DeleteOutlined
              onClick={() => handleDelete2(record)}
              style={{ cursor: 'pointer' }}
            />
          </Row>
        );
      },
      width: 10,
      title: '  ',
      className: 'pr-8',
    },
  ];

  const handleDelete = (record: any) => {
    if (record) {
      console.log('record', record);
      setTpList((prevList) =>
        prevList.filter((item) => item.tpid !== record.tpid)
      );
      setTpChildChanges((prevChanges) => [
        ...prevChanges,
        { ...record, operation: 'DELETE' },
      ]);
    } else {
      console.error(
        'Unable to delete: record or tpreference is undefined',
        record
      );
    }
  };

  const handleDelete2 = (record: any) => {
    if (record) {
      setTpList2((prevList2) =>
        prevList2.filter((item) => item.tpreference !== record.tpreference)
      );
      setTpChildChanges((prevChanges) => [
        ...prevChanges,
        { ...record, operation: 'DELETE' },
      ]);
    } else {
      console.error(
        'Unable to delete: record or tpreference is undefined',
        record
      );
    }
  };

  const stepsContent = {
    step1: (
      <Spin spinning={isFetching}>
        <GeneralDataSuperTP form={form} required />
      </Spin>
    ),
    step2: (
      <>
        <Title
          comcode="addmoraltp_title"
          level={4}
          className="ut-updateTP-title mb-7"
        />

        <div>
          <DataGrid
            columns={columns}
            dataSource={tpList}
            rowKey="tpid"
            hideFilters
            hideTitle
            pagination={false}
            hideExtraAction
          />

          <Row justify="center" style={{ marginTop: 20 }}>
            <ModalControllerNV
              modal={({ setVisible, visible }) => (
                <ThirdPartySearchModal
                  initialSearchParams={{ tptype: 'PM', noparent: true }}
                  key={'PM'}
                  visible={visible}
                  onCancel={() => setVisible(false)}
                  isProposalCreate={false}
                  onlyPM
                  title="addpmtp"
                  onSelectTp={(listtp) => {
                    console.log('listtp', listtp);
                    addTpToList(listtp);
                    setVisible(false);
                  }}
                />
              )}
              content={({ setVisible }) => (
                <ButtonLink
                  htmlType="button"
                  comcode="addtpmoral"
                  onClick={() => !isInspect && setVisible(true)}
                  iconPosition="end"
                  className="ut-btn-bordred"
                  icon={
                    <PlusOutlined
                      onClick={() => {
                        setVisible(true);
                      }}
                    />
                  }
                />
              )}
            />
          </Row>
        </div>
      </>
    ),
    step3: (
      <>
        <Title
          comcode="addconc_msg"
          level={4}
          className="ut-updateTP-title mb-7"
        />

        <div>
          <DataGrid
            columns={columns2}
            dataSource={tpList2}
            rowKey="tpid"
            hideFilters
            hideTitle
            pagination={false}
            hideExtraAction
          />
        </div>

        <Row justify="center" style={{ marginTop: '20px' }}>
          <ModalControllerNV
            modal={({ setVisible, visible }) => (
              <ThirdPartySearchModal
                initialSearchParams={{ tptype: 'CONC', noparent: true }}
                key={'CONC'}
                visible={visible}
                onCancel={() => setVisible(false)}
                isProposalCreate={false}
                title="addconctp"
                onlyConc
                onSelectTp={(listtp2) => {
                  addTpToList2(listtp2); // Add only unique items
                  setVisible(false);
                }}
              />
            )}
            content={({ setVisible }) => (
              <ButtonLink
                htmlType="button"
                comcode="addtpphysique"
                onClick={() => {
                  !isInspect && setVisible(true);
                }}
                iconPosition="end"
                className="ut-btn-bordred"
                icon={
                  <PlusOutlined
                    onClick={() => {
                      setVisible(true);
                    }}
                  />
                }
              />
            )}
          />
        </Row>
      </>
    ),
  };

  const steps1 = [
    { stepcomcode: 'GeneralData', key: 'step1' },
    { stepcomcode: 'addmoraltp', key: 'step2' },
    { stepcomcode: 'addconctp', key: 'step3' },
  ];
  useEffect(() => {
    if (thirdParty) {
      // thirdParty.companyHierarchyTree

      form.setFieldsValue({
        tpclass: thirdParty?.generalData?.tpclass,
        tpclasslabel: thirdParty?.generalData?.tpclasslabel,
        tpclassdate: thirdParty?.generalData?.tpclassdate,
        tprevenue: thirdParty?.generalData?.tprevenue,
        tprevenuereferenceyear: toDatePickerDate(
          thirdParty?.generalData?.tprevenuereferenceyear
        ),
        tpidentitycardcountry: thirdParty?.generalData?.tpidentitycardcountry,
        tpidentitycardexpirationdate: toDatePickerDate(
          thirdParty?.generalData?.tpidentitycardexpirationdate
        ),
        tpactivitysector: thirdParty?.generalData?.tpactivitysector,
        tpflagresident: thirdParty?.generalData?.tpflagresident,
        tpcategory: thirdParty?.generalData?.tpcategory,
        tpcompanysize: thirdParty?.generalData?.tpcompanysize,
        tpparentcompanyid: thirdParty?.additionalInfo?.tpparentcompanyid,
        tpparentcompanyname: thirdParty?.generalData?.tpparentcompanyname,
        tpfree1: thirdParty?.additionalInfo?.tpfree1,
        tpfree2: thirdParty?.additionalInfo?.tpfree2,
        tpfree3: thirdParty?.additionalInfo?.tpfree3,
        tpfree4: thirdParty?.additionalInfo?.tpfree4,
        tpfree5: thirdParty?.additionalInfo?.tpfree5,
        tpdescription: thirdParty?.additionalInfo?.tpdescription,
        tpid: thirdParty?.generalData?.tpid,
        currcode: thirdParty?.generalData?.currcode,
        tpreference: thirdParty?.generalData?.tpreference,
        tptype: thirdParty?.generalData?.tptype,
        tptypelabel: thirdParty?.generalData?.tptypelabel,

        tpkycstatuslabel: thirdParty?.generalData?.tpkycstatuslabel,
        tpkycstatus: thirdParty?.generalData?.tpkycstatus,
        tpkycdate: thirdParty?.generalData?.tpkycdate?.substring(0, 10),
        tpstatuslabel: thirdParty?.generalData?.tpstatuslabel,
        tpstatusdate: thirdParty?.generalData?.tpstatusdate?.substring(0, 10),
        tpstatuslabelgeneraldata:
          thirdParty?.generalData?.tpstatuslabel +
          ' (' +
          thirdParty?.generalData?.tpstatusdate?.substring(0, 10) +
          ')',
        tpbrokerid: thirdParty?.generalData?.tpbrokerid,
        tplegalform: thirdParty?.generalData?.tplegalform,
        tpname: thirdParty?.generalData?.tpname,
        tpsurname: thirdParty?.generalData?.tpsurname,
        tpmiddlename: thirdParty?.generalData?.tpmiddlename,
        tpmaidenname: thirdParty?.generalData?.tpmaidenname,
        tpmarketingname: thirdParty?.generalData?.tpmarketingname,
        tpmanagername: thirdParty?.generalData?.tpmanagername,
        tpmanagerposition: thirdParty?.generalData?.tpmanagerposition,
        tpactivity: thirdParty?.generalData?.tpactivity,
        tpbranchid: thirdParty?.generalData?.tpbranchid,
        mgid: thirdParty?.generalData?.mgid,
        lancode: thirdParty?.generalData?.lancode,
        countcode: thirdParty?.generalData?.countcode,
        tpcompanycreationdate: toDatePickerDate(
          thirdParty?.generalData?.tpcompanycreationdate
        ),
        tpflagvatexemption: thirdParty?.generalData?.tpflagvatexemption,
        tpvatexemtionenddate: toDatePickerDate(
          thirdParty?.generalData?.tpvatexemtionenddate
        ),
        tpfiscalid: thirdParty?.generalData?.tpfiscalid,
        tpfiscalcity: thirdParty?.generalData?.tpfiscalcity,
        tptaxid: thirdParty?.generalData?.tptaxid,
        tpsalutationcode: thirdParty?.generalData?.tpsalutationcode,
        tpgender: thirdParty?.generalData?.tpgender,
        tpbirthdate: toDatePickerDate(thirdParty?.generalData?.tpbirthdate),
        tpbirthcity: thirdParty?.generalData?.tpbirthcity,
        tpbirthcountry: thirdParty?.generalData?.tpbirthcountry,
        tpprofession: thirdParty?.generalData?.tpprofession,
        tpidentitycardtype: thirdParty?.generalData?.tpidentitycardtype,
        tpidentitycardid: thirdParty?.generalData?.tpidentitycardid,
        tpmaritalstatus: thirdParty?.generalData?.tpmaritalstatus,
        tpnbofchildren: thirdParty?.generalData?.tpnbofchildren,
        tpworkingctdate: toDatePickerDate(
          thirdParty?.generalData?.tpworkingctdate
        ),
        tpworkingcttype: thirdParty?.generalData?.tpworkingcttype,
        tporigin: thirdParty?.generalData?.tporigin,
        tpspecialtag: thirdParty?.generalData?.tpspecialtag,

        parentCompany: {
          tpid: thirdParty?.generalData?.tpparentcompanyid,
          tpname: thirdParty?.generalData?.tpparentcompanyidname,
          tpreference: thirdParty?.generalData?.tpparentcompanyidreference,
        },
        tptradingid: thirdParty?.generalData?.tptradingid,
        tpcompanyid: thirdParty?.generalData?.tpcompanyid,

        tpparentcompanyidreference:
          thirdParty?.generalData?.tpparentcompanyidreference,
        tpparentcompanyidname: thirdParty?.generalData?.tpparentcompanyidname,
        tpcapital: thirdParty?.generalData?.tpcapital,
        tpbrand: thirdParty?.generalData?.tpbrand,
        tpcapitalholding: Number(thirdParty?.generalData?.tpcapitalholding),
        tppoliticallyexposedperson:
          thirdParty?.generalData?.tppoliticallyexposedperson,
        tpantimoneylaunder: thirdParty?.generalData?.tpantimoneylaunder,
        tpmainadrstreet1: thirdParty?.address?.tpmainadrstreet1,
        tpmainadrstreet2: thirdParty?.address?.tpmainadrstreet2,
        tpmainadrstreet3: thirdParty?.address?.tpmainadrstreet3,
        tpmainadrcity: thirdParty?.address?.tpmainadrcity,
        tpmainadrzipcode: thirdParty?.address?.tpmainadrzipcode,
        tpmainadrregion: thirdParty?.address?.tpmainadrregion,
        tpmainadrregionglobale: thirdParty?.address?.tpmainadrregionglobale,
        tpmainadrcountry: thirdParty?.address?.tpmainadrcountry,
        tpsecadrstreet1: thirdParty?.address?.tpsecadrstreet1,
        tpsecadrstreet2: thirdParty?.address?.tpsecadrstreet2,
        tpsecadrcity: thirdParty?.address?.tpsecadrcity,
        tpsecadrzipcode: thirdParty?.address?.tpsecadrzipcode,
        tpsecadrregion: thirdParty?.address?.tpsecadrregion,
        tpsecadrcountry: thirdParty?.address?.tpsecadrcountry,
        bkaccountkeymain: thirdParty?.bankAccount?.bkaccountkey,
        bkaccountnummain: thirdParty?.bankAccount?.bkaccountnum,
        bkbranchcodemain: thirdParty?.bankAccount?.bkbranchcode,
        bkcodemain: thirdParty?.bankAccount?.bkcode,
        bktypemain: thirdParty?.bankAccount?.bktype,
        tpibanmain: thirdParty?.bankAccount?.tpiban,
        tpbicmain: thirdParty?.bankAccount?.tpbic,
        tpbanknamemain: thirdParty?.bankAccount?.tpbankname,
        tpcbtype: thirdParty?.bankAccount?.tpcbtype,
        tpcbnummain: thirdParty?.bankAccount?.tpcbnum,
        tpcbdatemain: thirdParty?.bankAccount?.tpcbdate,
        tpcbkeymain: thirdParty?.bankAccount?.tpcbkey,
        tpcbnamemain: thirdParty?.bankAccount?.tpcbname,
        tptel1: thirdParty?.contact?.tptel1,
        tptelmobile1: thirdParty?.contact?.tptelmobile1,
        tpemail1: thirdParty?.contact?.tpemail1,
        tpcontactname1: thirdParty?.contact?.tpcontactname1,
        tpcontactposition1: thirdParty?.contact?.tpcontactposition1,
        tptel2: thirdParty?.contact?.tptel2,
        tptelmobile2: thirdParty?.contact?.tptelmobile2,
        tpemail2: thirdParty?.contact?.tpemail2,
        tpcontactname2: thirdParty?.contact?.tpcontactname2,
        tpcontactposition2: thirdParty?.contact?.tpcontactposition2,
        tpsaleuserid: thirdParty?.correspondent?.tpsaleuserid,
        tpsaleusername: thirdParty?.correspondent?.tpsaleusername,
        tpsaleuserdate: thirdParty?.correspondent?.tpsaleuserdate?.substring(
          0,
          10
        ),
        tpriskuserid: thirdParty?.correspondent?.tpriskuserid,
        tpriskusername: thirdParty?.correspondent?.tpriskusername,
        tpriskuserdate: thirdParty?.correspondent?.tpriskuserdate?.substring(
          0,
          10
        ),
        tpbouserid: thirdParty?.correspondent?.tpbouserid,
        tpbousername: thirdParty?.correspondent?.tpbousername,
        tpbouserdate: thirdParty?.correspondent?.tpbouserdate?.substring(0, 10),
        tprecuserid: thirdParty?.correspondent?.tprecuserid,
        tprecusername: thirdParty?.correspondent?.tprecusername,
        tprecuserdate: thirdParty?.correspondent?.tprecuserdate?.substring(
          0,
          10
        ),
        tplpuserid: thirdParty?.correspondent?.tplpuserid,
        tplpusername: thirdParty?.correspondent?.tplpusername,
        tplpuserdate: thirdParty?.correspondent?.tplpuserdate?.substring(0, 10),
        tpemployer: thirdParty?.income?.tpemployer,
        tpemployeraddress: thirdParty?.income?.tpemployeraddress,
        tpemloyertel: thirdParty?.income?.tpemloyertel,
        tpmonthlyincome: thirdParty?.income?.tpmonthlyincome,
        tpothersincome: thirdParty?.income?.tpothersincome,
        tpfamilybenefits: thirdParty?.income?.tpfamilybenefits,
        tpothersexpense: thirdParty.income?.tpothersexpense,
        tpotherloan: thirdParty?.income?.tpotherloan,
        tpflagclient: thirdParty?.role?.tpflagclient,
        tpflagsupplier: thirdParty?.role?.tpflagsupplier,
        tpflagguarantor: thirdParty?.role?.tpflagguarantor,
        tproleother: thirdParty?.role?.tproleother,
        tppaymodein: thirdParty?.role?.tppaymodein,
        tppaydelayin: thirdParty?.role?.tppaydelayin,
        tppaymodeout: thirdParty?.role?.tppaymodeout,
        tppaydelayout: thirdParty?.role?.tppaydelayout,
        tplateinterestformula: thirdParty?.role?.tplateinterestformula,
        tpblocklateinterestinvoicing:
          thirdParty.role?.tpblocklateinterestinvoicing,
        tpreminderfeesformula: thirdParty?.role?.tpreminderfeesformula,
        tpblockreminderfeesinvoicing:
          thirdParty?.role?.tpblockreminderfeesinvoicing,
        tpblockrejectionfeesinvoicing:
          thirdParty?.role?.tpblockrejectionfeesinvoicing,
        tprejectionfeesformula: thirdParty?.role?.tprejectionfeesformula,

        spname: thirdParty?.spouse?.spname,
        spsurname: thirdParty?.spouse?.spsurname,
        spgender: thirdParty?.spouse?.spgender,
        spbirthdate: toDatePickerDate(thirdParty?.spouse?.spbirthdate),
        spbirthcity: thirdParty?.spouse?.spbirthcity,
        spbirthcountry: thirdParty?.spouse?.spbirthcountry,
        spmaidenname: thirdParty?.spouse?.spmaidenname,

        spsalutationcode: thirdParty?.spouse?.spsalutationcode,
        spfiscalid: thirdParty?.spouse?.spfiscalid,
        spprofession: thirdParty?.spouse?.spprofession,
        spidentitycardtype: thirdParty?.spouse?.spidentitycardtype,
        spidentitycardid: thirdParty?.spouse?.spidentitycardid,
        spemployer: thirdParty?.spouse?.spemployer,
        spemployeraddress: thirdParty?.spouse?.spemployeraddress,
        spemloyertel: thirdParty?.spouse?.spemloyertel,
        spmonthlyincome: thirdParty?.spouse?.spmonthlyincome,
        spothersincome: thirdParty?.spouse?.spothersincome,
        spothersexpense: thirdParty?.spouse?.spothersexpense,
        spotherloan: thirdParty?.spouse?.spotherloan,
        tpsalestatuslabel: thirdParty?.status?.tpsalestatuslabel,
        tpsalestatusdate: thirdParty?.status?.tpsalestatusdate?.substring(
          0,
          10
        ),
        tpriskstatuslabel: thirdParty?.status?.tpriskstatuslabel,
        tpriskstatusdate: thirdParty?.status?.tpriskstatusdate?.substring(
          0,
          10
        ),
      });
      const pmList = thirdParty.tpChildrenList?.filter(
        (tp: { tptype: string }) => tp.tptype === 'PM'
      );
      const concList = thirdParty.tpChildrenList?.filter(
        (tp: { tptype: string }) => tp.tptype === 'CONC'
      );
      setTpList(pmList);
      setTpList2(concList);
    } else {
      form.resetFields();
    }
  }, [thirdParty, form]);

  const prepareThirdPartyRequest = (values: any): any => {
    // const tpChildList = [...tpList, ...tpList2].map((tp) => tp.tpid);
    return {
      additionalInfo: {
        tpparentcompanyid: null,
        tpparentcompanyname: values?.tpparentcompanyname,
        tpfree1: values?.tpfree1,
        tpfree2: values?.tpfree2,
        tpfree3: values?.tpfree3,
        tpfree4: values?.tpfree4,
        tpfree5: values?.tpfree5,
        tpdescription: values?.tpdescription,
      },
      address: {
        tpmainadrstreet1: values?.tpmainadrstreet1,
        tpmainadrstreet2: values?.tpmainadrstreet2,
        tpmainadrstreet3: values?.tpmainadrstreet3,
        tpmainadrcity: values?.tpmainadrcity,
        tpmainadrzipcode: values?.tpmainadrzipcode,
        tpmainadrregion: values?.tpmainadrregion,
        tpmainadrregionglobale: values?.tpmainadrregionglobale,
        tpmainadrcountry: values?.tpmainadrcountry,
        tpsecadrstreet1: values?.tpsecadrstreet1,
        tpsecadrstreet2: values?.tpsecadrstreet2,
        tpsecadrcity: values?.tpsecadrcity,
        tpsecadrzipcode: values?.tpsecadrzipcode,
        tpsecadrregion: values?.tpsecadrregion,
        tpsecadrcountry: values?.tpsecadrcountry,
      },
      bankAccount: {
        bkaccountkey: values?.bkaccountkeymain,
        bkaccountnum: values?.bkaccountnummain,
        bkbranchcode: values?.bkbranchcodemain,
        bkcode: values?.bkcodemain
          ? values?.bkcodemain
          : form.getFieldValue('bkcodemain'),
        bktype: values?.bktype,
        countcode: values?.countcode,
        tpbkid: values?.tpbkid,
        currcode: values?.currcode,
        tpiban: values?.tpibanmain,
        tpbic: values?.tpbicmain,
        tpbankname: values?.tpbanknamemain,
        tpcbtype: values?.tpcbtype,
        tpcbnum: values?.tpcbnum,
        tpcbdate: values?.tpcbdate,
        tpcbkey: values?.tpcbkey,
        tpcbname: values?.tpcbname,
      },
      contact: {
        // tptel1: values?.tptel1?.replace(/\s+/g, ''),
        tptelmobile1: values?.tptelmobile1,
        tpemail1: values?.tpemail1,
        tpcontactname1: values?.tpcontactname1,
        tpcontactposition1: values?.tpcontactposition1,
        tptel2: values?.tptel2,
        tptelmobile2: values?.tptelmobile2,
        tpemail2: values?.tpemail2,
        tpcontactname2: values?.tpcontactname2,
        tpcontactposition2: values?.tpcontactposition2,
        tpcontactid: 0,
        tpid: 0,
        firstname: '',
        lastname: '',
        position: '',
        tel1: '',
        tel2: '',
        email: '',
      },
      generalData: {
        tpcompanyid: values?.tpcompanyid,
        tptradingid: values?.tptradingid,
        currcode: values?.currcode,
        tpid: values?.tpid,
        tptype: 'SPM',
        tpbrokerid: values?.tpbrokerid,
        tplegalform: values?.tplegalform,
        tpname: values?.tpname,
        tpsurname: values?.tpsurname,
        tpmiddlename: values?.tpmiddlename,
        tpmaidenname: values?.tpmaidenname,
        tpflagvatexemption: values?.tpflagvatexemption,
        tpvatexemtionenddate: values?.tpvatexemtionenddate,
        tpmarketingname: values?.tpmarketingname,
        tpmanagername: values?.tpmanagername,
        tpmanagerposition: values?.tpmanagerposition,
        tpactivity: values?.tpactivity,
        tpbranchid: values?.tpbranchid,
        tpbrand: values?.tpbrand,
        lancode: values?.lancode,
        countcode: values?.countcode,
        tpcompanycreationdate: values?.tpcompanycreationdate,
        tpfiscalid: null,
        tpfiscalcity: values?.tpfiscalcity,
        tptaxid: values?.tptaxid,
        tpsalutationcode: values?.tpsalutationcode,
        tpgender: values?.tpgender,
        tpbirthdate: values?.tpbirthdate,
        tpbirthcity: values?.tpbirthcity,
        tpbirthcountry: values?.tpbirthcountry,
        tpprofession: values?.tpprofession,
        tpidentitycardtype: values?.tpidentitycardtype,
        tpidentitycardid: values?.tpidentitycardid,
        tpmaritalstatus: values?.tpmaritalstatus,
        tppaymentdelegation: values?.tppayementdelegation,
        tpnbofchildren: values?.tpnbofchildren,
        tpworkingctdate: dateToString(values?.tpworkingctdate),
        tpworkingcttype: values?.tpworkingcttype,
        tpcapital: values?.tpcapital,
        tpcapitalholding: values?.tpcapitalholding,
        tpkycstatus: values?.tpkycstatus,
        tppoliticallyexposedperson: values?.tppoliticallyexposedperson,
        tpantimoneylaunder: values?.tpantimoneylaunder,
        tporigin: values?.tporigin,
        tpspecialtag: values?.tpspecialtag,
        tpparentcompanyid: null,
        last_action: wizData?.taskidCreate,
        tpflagresident: values?.tpflagresident,
        tpcategory: values?.tpcategory,
        tpcompanysize: values?.tpcompanysize,
        tprevenue: values?.tprevenue,
        tprevenuereferenceyear: values?.tprevenuereferenceyear,
        tpidentitycardcountry: values?.tpidentitycardcountry,
        tpidentitycardexpirationdate: dateToString(
          values?.tpidentitycardexpirationdate
        ),
        tpactivitysector: values?.tpactivitysector,
        tpreference: values?.tpreference,
        // tpflagconsentmain:values?.tpflagconsentmain,
        // tpflagconsent2:values?.tpflagconsent2,
        // tpflagconsent3:values?.tpflagconsent3,
        // tpflagconsent4:values?.tpflagconsent4,
        // tpflagconsent5:values?.tpflagconsent5,
        //not found in Api ThirdParty
      },
      income: {
        tpemployer: values?.tpemployer,
        tpemployeraddress: values?.tpemployeraddress,
        tpemloyertel: values?.tpemloyertel,
        tpmonthlyincome: values?.tpmonthlyincome,
        tpothersincome: values?.tpothersincome,
        tpfamilybenefits: values?.tpfamilybenefits,
        tpothersexpense: values?.tpothersexpense,
        tpotherloan: values?.tpotherloan,
      },
      role: {
        tpreminderfeesformula: values?.tpreminderfeesformula,
        tpblockreminderfeesinvoicing:
          values?.tpblockreminderfeesinvoicing === undefined
            ? false
            : values?.tpblockreminderfeesinvoicing,
        tpblockrejectionfeesinvoicing:
          values?.tpblockrejectionfeesinvoicing === undefined
            ? false
            : values?.tpblockrejectionfeesinvoicing,
        tprejectionfeesformula: values?.tprejectionfeesformula,

        tpflagclient: true,
        tpflagsupplier: true,
        tpflagguarantor: values?.tpflagguarantor,
        tproleother: values?.tproleother,
        tppaymodein: values?.tppaymodein,
        tppaydelayin: values?.tppaydelayin,
        tppaymodeout: values?.tppaymodeout,
        tppaydelayout: values?.tppaydelayout,
        tplateinterestformula: values?.tplateinterestformula,
        tpblocklateinterestinvoicing:
          values?.tpblocklateinterestinvoicing === undefined
            ? false
            : values?.tpblocklateinterestinvoicing,
      },
      spouse: {
        spname: values?.spname,
        spsurname: values?.spsurname,
        spgender: values?.spgender,
        spbirthdate: dateToString(values?.spbirthdate),
        spbirthcity: values?.spbirthcity,
        spbirthcountry: values?.spbirthcountry,
        spmaidenname: values?.spmaidenname,
        spsalutationcode: values?.spsalutationcode,
        spfiscalid: values?.spfiscalid,
        spprofession: values?.spprofession,
        spidentitycardtype: values?.spidentitycardtype,
        spidentitycardid: values?.spidentitycardid,
        spemployer: values?.spemployer,
        spemployeraddress: values?.spemployeraddress,
        spemloyertel: values?.spemloyertel,
        spmonthlyincome: values?.spmonthlyincome,
        spothersincome: values?.spothersincome,
        spothersexpense: values?.spothersexpense,
        spotherloan: values?.spotherloan,
      },
      tpChild: tpChildChanges,
    };
  };

  const onFinish = (e: any) => {
    // let tpListId = tpList?.map((tp: any) => tp.tpid);
    // let tpListId2 = tpList2?.map((tp: any) => tp.tpid);

    // const tpdData = prepareThirdPartyRequest(e);

    // console.log('this is tpdata=>', tpdData);
    form
      .validateFields(e)
      .then((values) => {
        const tpdData = prepareThirdPartyRequest(values);

        console.log('this is tpdata=>', tpdData);

        let generalData = {
          ...tpdData?.generalData,
          tpbirthdate: dateToString(tpdData?.generalData?.tpbirthdate),
        };

        const dataSave = {
          ...tpdData,
          generalData: generalData,
        };

        if (thirdParty) {
          setIsLoading(true);
          console.log('data to save', dataSave);
          updateThirdParty({
            ThirdPartyRequest: dataSave,
            tpid: Number(paramId),
          })
            .then((res) => {
              setIsLoading(false);
              if (res.code === '200') {
                // notification.success({
                //   message: 'ThirdParty updated successfully ',
                // });

                Notifications({
                  status: 'success',
                  message: 'Le tiers a été modifié.',
                  description: res.description,
                  duration: 3,
                  placement: 'topRight',
                });

                navigate(`/thirdparty-sfs/${res.data.generalData.tpid}/SPM`);
                thirdParty = res.data;
                refetch();
                setIsLoading(false);
              } else {
                notification.warning({
                  message: res.message,
                });
              }
            })
            .catch((err) => {
              setIsLoading(false);
              console.error('Error updating third party:', err);
              notification.error({
                message: 'Error updating third party',
                description: err.message,
              });
            });
        } else {
          setIsLoading(true);

          createThirdParty({ ThirdPartyRequest: dataSave })
            .then((res) => {
              setIsLoading(false);

              if (res.code === '200') {
                Notifications({
                  status: 'success',
                  message: 'Le tiers a été crée',
                  description: res.description,
                  duration: 3,
                  placement: 'topRight',
                });
                navigate(`/thirdparty-sfs/${res.data.generalData.tpid}/SPM`);
              } else {
                notification.error({
                  message: res.message,
                  description: res.description,
                });
                isModal && form.resetFields();
              }
            })
            .catch((err) => {
              setIsLoading(false);
              console.error('Error creating third party:', err);
              notification.error({
                message: 'Error creating third party',
                description: err.message,
              });
            });
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.error('Form validation error:', err);
        notification.error({
          message: 'Form validation error',
          description: 'Please check the form for errors and try again.',
        });
      });
    // setLoading(false)
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={(values) => {
        onFinish(values);
      }}
    >
      <TitlePage
        level={2}
        comcode={paramId ? 'UpdateSuperTp' : 'NewSuperTp'}
        bgColor="blue"
      />
      <Spin spinning={isLoading}>
        <div className="container-stepper" style={{ marginTop: 15, marginBottom: 60 }}>
          <Row >
            <Title
              comcode="infoToComplete"
              level={4}
              className="ut-updateTP-title mb-7 mt-10"
            />
          </Row>
          <WizardSteps
            steps={steps1}
            stepsContent={stepsContent}
            direction="horizontal"
            currentStep={current}
            onNext={next}
            onPrev={prev}
            nextComcode="Next"
            prevComcode={current === 0 ? 'Réinitialiser' : 'Previous'}
            doneComcode="Done"
            className="my-custom-class"
            onCancel={() => { navigate(-1) }}
          />
        </div>
      </Spin>
    </Form>
  );
};

export default TabSuperCompany;
